import { Injectable } from '@angular/core';
import { SelectionState } from '@alfresco/adf-extensions';
import { from, Observable } from 'rxjs';
import { AldenService } from './alden.service';

export interface ActionDialogConfig {
  selection: SelectionState;
  totalItems?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SmtActionsService {

  constructor(private aldenService: AldenService) {}

  /**
   * Exporta los metadatos de todos los documentos que cumplan la query indicada.
   *
   * Este método realiza una llamada al endpoint `/excel/export-metadata` del backend,
   * enviando la query completa y solicitando la respuesta en formato `blob`. El backend
   * genera un Excel con los metadatos de los documentos filtrados.
   *
   * Se utiliza cuando el usuario desea exportar información masiva en formato Excel
   * sin descargar los documentos en sí.
   *
   * @param query Objeto de consulta que define los filtros y criterios de búsqueda.
   * @returns Observable con la respuesta del backend en formato `blob`.
   */
  exportAllDocsByQuery(query: any): Observable<any> {
    return from(this.aldenService.callAlfresco('smt/excel/export-metadata','POST',{},{},{},query,['application/json'],
      ['application/json','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],'blob'));
  }

  /**
   * Descarga masivamente todos los documentos que cumplan la query indicada.
   *
   * Este método llama al endpoint `/exportData/documents/massive/download`, enviando
   * la query completa para que el backend genere un paquete descargable con todos los
   * documentos que coinciden con los filtros aplicados.
   *
   * A diferencia de `exportAllDocsByQuery`, este método no exporta metadatos, sino
   * los documentos reales en un único archivo comprimido.
   *
   * @param query Objeto de consulta que define los filtros y criterios de búsqueda.
   * @returns Observable con la respuesta del backend, normalmente un archivo descargable.
   */
  downloadAllDocsByQuery(query: any): Observable<any> {
    return from(this.aldenService.callAlfresco('/smtecno/ssm/exportData/documents/massive/download','POST',{},{},{},query,
      ['application/json'],['application/json'],''));
  }
}
